import theme_ from './CurrentTheme';

const theme = theme_;

const globalStyles = {
    body: {
        fontFamily: "'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
        fontSmooth: 'auto',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        //backgroundImage: "url('/images/background.jpg')",
        backgroundColor: theme.pageBackgroundColor,
        //backgroundColor: theme => theme.

        minWidth: theme.pageMinWidth,
        minHeight: theme.pageMinHeight,
        overflow: 'auto',
    },

    code: {
        fontFamily: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace",
    },

    // //".MuiDataGrid-row.Mui-odd": {
    //     root: {
    // //".MuiDataGrid-row:nth-child(even)": {
    // ".MuiDataGrid-row": {
    //         backgroundColor: 'aliceblue',
    // },    

    // },

    // ".aaa": {
    //     backgroundColor: 'red',
    // },

    // .MuiDataGrid-row:nth-child(even){
    //     background-color: aliceblue;
    //   }
}

export default globalStyles;


